/**
 * PaletteSearchInput — wspólny input wyszukiwarki dla palet buildera formularza.
 *
 * Używany nad listą PÓL i nad listą ELEMENTÓW w każdym builderze (moduł systemowy,
 * moduł własny, edytor subkolekcji). Filtrowanie robi konsument przez
 * `normalizeSearch` (diakrytyka-insensitive) — ten komponent trzyma tylko UI inputa
 * (prymitiv `Input` + ikona lupy), żeby wygląd wyszukiwarek był spójny globalnie.
 */

import { Search } from 'lucide-react';

import { Input } from '@/components/Input';

interface PaletteSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  testId?: string;
}

export function PaletteSearchInput({
  value,
  onChange,
  placeholder,
  testId,
}: PaletteSearchInputProps) {
  return (
    <Input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
      prefixIcon={<Search className="h-3.5 w-3.5" />}
      className="py-1.5 text-xs"
      containerClassName="mb-2"
      data-testid={testId}
    />
  );
}
